/**
 * Utility function to format tenant type for display
 * Converts backend values to user-friendly display text
 * - CUSTOMER -> Customer
 * - LSP -> Local Team
 * - LOCAL_TEAM -> Local Team
 * - Any other value: capitalize first letter, rest lowercase
 */

const tenantTypeMap = {
  CUSTOMER: "Customer",
  LSP: "Local Team",
  LOCAL_TEAM: "Local Team",
};

/**
 * Format tenant type for display
 * @param {string} type - The tenant type from backend
 * @returns {string} - The formatted display text
 */
export const formatTenantType = (type) => {
  if (!type || typeof type !== "string") return type;

  // Check for exact matches in the map
  if (tenantTypeMap[type]) {
    return tenantTypeMap[type];
  }

  // For any other value: capitalize first letter, rest lowercase
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
};
